<template>
  <a-card :bordered="false" class="m-b-20">
    <a-form  :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" @change="changeWeek" v-model:value="weekTime" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
        <!-- <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="经销商"></a-tab-pane>
            <a-tab-pane key="2" tab="门店"></a-tab-pane>
        </a-tabs> -->
   <a-form class='m-t-20 m-b-20'  :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="经销商名称" >
          <a-input  v-model:value="form.product_name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
        <a-form-item label="经销商级别" >
          <a-input  v-model:value="form.product_sku_name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered  :columns='analyzeColumns' :data-source='detail.list'>
      <template v-slot:action="{ record }">
        <a href="javascript:;" v-has:antiStatisticsDullGoodDetail="()=>{$router.push({path:'/antiFleeingGoods/statistics/channelSluggishGoodsAnalyze',query:{'dealer_id':record.dealer_id,'dealer_name':record.dealer_name,'search_time':search.search_time,'search_date_type':search.search_date_type}})}">查看分析</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="search.total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { channelDeadProduct } from "@/api/antiFleeing";
import { message } from "ant-design-vue";
import { iscode } from '../../../../utils/app';

export default {
  components: {},
  setup() {
    const momentTime = inject("momentTime");
    const search = ref({
      start_time: "",
      total:0,
      limit:10,
      pages:1,
      search_date_type:"1"
    });
    const state = reactive({
      list: [],
      total: 0,
      detail: {},
           disabledDate:function(current) {
        return current && current > momentTime().subtract(0, 'days').endOf('day')
      },
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          break;
        case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          break;
        case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
      }
    };
    // 切换周
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    let analyzeColumns=[
       {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商级别",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
    {
        title: "呆滞商品数量",
        dataIndex: "code_num",
        key: "code_num",
      },
          {
        title: "操作",
        dataIndex: "action",
        key: "action",
          slots: { customRender: "action" },
      },
    ]
    var $moment = inject("momentTime");
    var $route = inject("$route");
    const form=ref({
      warehouse_id:'',
      warehouse_name:"",
      warehouse_position_name:'',
      product_name:'',
      product_sku_name:'',
    })
    const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      let result = await channelDeadProduct({
        ...search.value
      })
        .then((res) => res.data)
        .catch((error) => error);
      // 整理数据
      var chartsList = [];
      state.detail = result.data;
      search.value.total = result.data.total;
      return chartsList;
    };
    const changNav =  () => {
      getLine();
    }
         // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
       getLine()
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
     getLine()
    };
    onMounted(() => {
      handleChange("1");
      changNav(1);
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      handleChange,
      changNav,
      onSearch,
      changeWeek,
      form,
      analyzeColumns
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
}
</style>